import React, { Component } from 'react';
import {
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  Row,
  Col,
} from "reactstrap";

class BankDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bank_loan_amount: '',
      bank_id: '',
      loanAmountValid:'',
    }
  }

  render() {
    return (
      <div>
      <FormGroup row>
        <Col md="4">
          <Label htmlFor="select">Bank Name</Label>
        </Col>
        <Col md="4">
          <Input type="select" name="bank_id" id="select" value="bank_id" onChange={(event) => this.props.handleUserInput(event)}>
            <option value="0">Please select</option>
            <option value="1">HDFC</option>
            <option value="2">ICICI</option>
            <option value="3">TATA</option>
            <option value="4">Bajaj</option>
          </Input>
        </Col>
      </FormGroup>
      <FormGroup row>
      <Col md="4">
          <Label htmlFor="text-input">Bank Loan Amount</Label>
        </Col>
        <Col md="4">
          <InputGroup className="input-prepend">
              <InputGroupAddon><i className="fa fa-inr"></i></InputGroupAddon>
              <Input type="number" id="text-input" name="bank_loan_amount" className={this.props.loanAmountValid} placeholder="" onChange={(event) => this.props.handleUserInput(event)}/>
          </InputGroup>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col md="4">
          <Label htmlFor="text-input">Bank Loan Rate</Label>
        </Col>
        <Col md="4">
          <InputGroup className="input-prepend">
              <InputGroupAddon>%</InputGroupAddon>
              <Input type="number" id="bank_loan_rate" name="bank_loan_rate" className={this.props.bankRateValid} placeholder="" onChange={(event) => this.props.handleUserInput(event)}/>
          </InputGroup>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col md="4">
          <Label htmlFor="select">Bank Loan tenure</Label>
        </Col>
        <Col md="4">
          <Input type="select" name="bank_loan_tenure" id="select" onChange={(event) => this.props.handleUserInput(event)}>
            <option value="0">Please select</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
            <option value="24">24</option>
            <option value="25">25</option>
            <option value="26">26</option>
            <option value="27">27</option>
            <option value="28">28</option>
            <option value="29">29</option>
            <option value="30">30</option>

          </Input>
        </Col>
      </FormGroup>      
      <FormGroup row>
        <Col md="4">
          <Label htmlFor="text-input">Bank loan disbursal date</Label>
        </Col>
        <Col md="4">
          <Input type="date" name="bankLoanDisbursalDate" id="exampleDate" placeholder="date placeholder" />
        </Col>
      </FormGroup>
      </div>
    )
  }
}

export default BankDetails;



// WEBPACK FOOTER //
// ./src/views/Pages/LoanForm/BankDetails.js